import PropTypes from 'prop-types';
import queryString from 'query-string';
import React from 'react';
import { Col, Grid, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Field, Form, propTypes, reduxForm } from 'redux-form';
import { login as loginAction } from '../../reducers/currentUser/currentUser.actions';
import {
  isAuthenticated as isAuthenticatedProperty,
  role as roleProperty,
} from '../../reducers/currentUser/currentUser.reducer';
import { ErrorAlert } from '../ErrorAlert/ErrorAlert';
import { admin, foreman, pm } from '../Routes/RoutePaths';
import SpinnerButton from '../SpinnerButton/SpinnerButton';
import './Login.css';
import LoginFormGroup from './LoginFormGroup/LoginFormGroup';

// eslint-disable-next-line object-curly-newline
export const Login = ({ handleSubmit, error, userRole, submitting, isAuthenticated, login, location }) => (
  <Form onSubmit={handleSubmit(login)} className="form-signin" >
    {isAuthenticated && userRole === 'admin' && <Redirect to={admin} /> }
    {isAuthenticated && userRole === 'foreman' && <Redirect to={foreman} /> }
    {isAuthenticated && userRole === 'pm' && <Redirect to={pm} /> }
    {isAuthenticated && queryString.parse(location.search).back && <Redirect to={queryString.parse(location.search).back} />}
    <Row>
      <Col xs={12} sm={6} smOffset={3} >
        <Grid fluid >
          <Row>
            <Col>
              <h3>SCG Time Tracker</h3>
              <ErrorAlert>{error}</ErrorAlert>
            </Col>
          </Row>
          <Row>
            <Col>
              <Field
                component={LoginFormGroup}
                name="username"
                placeholder="Username"
                type="text"
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <Field
                component={LoginFormGroup}
                name="password"
                placeholder="Password"
                type="password"
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <SpinnerButton
                isLoading={submitting}
                type="submit"
                bsStyle="primary"
              > Login
              </SpinnerButton>
            </Col>
          </Row>
        </Grid>
      </Col>
    </Row>
  </Form >
);

Login.propTypes = {
  ...propTypes,
  login: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
};

export const mapStateToProps = state => ({
  isAuthenticated: isAuthenticatedProperty(state),
  userRole: roleProperty(state),
});

export const mapDispatchToProps = dispatch => ({
  login: ({ username, password }) => loginAction(username, password).then(r => dispatch(r)),
});

export default reduxForm({ form: 'login' })(connect(mapStateToProps, mapDispatchToProps)(Login));



// WEBPACK FOOTER //
// ./src/components/Login/Login.jsx